export default {
  slug: "teeth-cleaning-in-guwahati",
  title: "Teeth Cleaning in Guwahati - Scaling and Polishing",
  subtitle:
    "Gentle and advanced ultrasonic scaling for healthy gums and a brighter smile",
  heroImage: "/dental-services/teeth-cleaning/best-teeth-cleaning-in-guwahati.webp",

  sections: [
    {
      type: "text",
      heading: "Professional Teeth Cleaning in Guwahati",
      content: `
Looking for professional teeth cleaning in Guwahati?  
At Magnum Dental Clinic, Guwahati, we provide gentle and advanced ultrasonic scaling and polishing to ensure a comfortable, effective, and thorough cleaning experience.

Professional teeth cleaning, also known as scaling and polishing, removes plaque, calculus (tartar), and stains that cannot be removed by regular brushing and flossing at home.
      `,
    },
    {
      type: "image",
      images: [
        "/dental-services/dental-scaling-in-guwahati.webp",
        "/dental-services/scaling-in-guwahati.webp",
        "/dental-services/teeth-cleaning-in-guwahati.webp",
        "/dental-services/ultrasonic-scaling.webp",
      ],
      caption: "Images are for illustrative  purposes only",
    },
    {
      type: "text",
      heading: "What is Ultrasonic Scaling?",
      content: `
Ultrasonic scaling is a modern dental cleaning technique that uses high-frequency vibrations to break down and remove hardened plaque (calculus) and bacterial deposits from teeth and along the gum line.

Unlike traditional manual tools, ultrasonic scalers:
• Vibrate at high speed  
• Loosen stubborn calculus  
• Flush out bacteria using a gentle water spray  

This makes the procedure more efficient, comfortable, and thorough.
      `,
    },

    {
      type: "text",
      heading: "Benefits of Ultrasonic Scaling",
      content: `
Ultrasonic scaling offers several advantages over conventional cleaning methods:

• Effectively removes hardened calculus and plaque  
• Helps prevent gum disease (gingivitis and periodontitis)  
• Reduces bad breath (halitosis)  
• Improves overall gum health  
• Gentler on teeth and gums  
• Faster and more comfortable experience  

Regular ultrasonic scaling plays a vital role in maintaining long-term oral health.
      `,
    },

    {
      type: "text",
      heading: "What is Teeth Polishing?",
      content: `
Teeth polishing is the final step after scaling.  
It smoothens the tooth surface using a special polishing paste and a rotating brush or rubber cup.

Polishing helps to:
• Remove surface stains caused by tea, coffee, or smoking  
• Make teeth feel smooth and clean  
• Enhance the natural shine of your teeth  

Together, scaling and polishing leave your mouth feeling fresh, clean, and healthy.
      `,
    },

    {
      type: "text",
      heading: "Why is Professional Teeth Cleaning Important?",
      content: `
Even if you brush twice daily, plaque can harden into tartar within 24–72 hours.  
Once tartar forms, it cannot be removed by brushing alone.

Professional teeth cleaning helps to:
✔ Prevent gum bleeding and inflammation  
✔ Reduce tooth sensitivity caused by plaque buildup  
✔ Protect the supporting bone around teeth  
✔ Maintain fresh breath  
✔ Avoid costly dental treatments in the future
      `,
    },

    {
      type: "text",
      heading: "How Often Should You Get Teeth Cleaning Done?",
      content: `
Most people should get professional teeth cleaning once every 6 months.

However, if you have:
• Gum disease  
• Heavy plaque buildup  
• A history of periodontal problems  

Your dentist may recommend more frequent cleanings.
      `,
    },
  ],

  faqs: [
    {
      q: "Is ultrasonic scaling painful?",
      a: "Ultrasonic scaling is generally comfortable. You may feel mild vibrations and water spray, but most patients find it painless. Extra gentle care is provided for sensitive gums.",
    },
    {
      q: "Does scaling damage teeth?",
      a: "No. Scaling does not damage your teeth. It removes harmful deposits that can weaken gums and lead to tooth loss if left untreated.",
    },
    {
      q: "Can scaling make my teeth loose?",
      a: "No. If teeth feel loose after cleaning, it is usually due to pre-existing gum disease. Scaling helps stop further damage.",
    },
    {
      q: "Will scaling make my teeth white?",
      a: "Scaling removes stains and tartar, making teeth look cleaner and brighter, but it does not change the natural tooth color like whitening treatments.",
    },
    {
      q: "Can I eat after teeth cleaning?",
      a: "Yes. However, if you experience sensitivity, avoid very hot, cold, or strongly colored foods for a few hours.",
    },
  ],

  cta: {
    heading: "Book Teeth Cleaning in Guwahati",
    description: `
Maintain a healthy and bright smile with professional teeth cleaning. Early care keeps your gums and teeth healthy.

For pricing details, please call us or visit our clinic for a consultation.

📍 Location: First Floor, Global Tower, Near Mangalam Grand, Pathar Quarry, VIP Road, Guwahati, Assam

📞 Call at 8638940021 to book your appointment

🦷 Your smile deserves expert care!
  `,
    buttonText: "Book Your Teeth Cleaning Appointment",
    link: "/book-appointment-dental-clinic-guwahati",
  },
};
